"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});

var _Card = _interopRequireDefault(require("./Card"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Card/index.js
// module id = 205
// module chunks = 0